import React, { useState, useEffect } from "react";
import { MdRemoveCircle } from "react-icons/md";

import { MuiTextField } from "../../../../components/InputFields/MuiTextField";
import { MuiItemAutoComplete } from "./MuiItemAutoComplete";

export const WatchItemsList = ({
  item,
  index,
  append,
  remove,
  register,
  control,
  errors,
  getValues,
  setValue,
  watchProduct,
  productList,
  onAddNewItem,
}) => {
  //   const [totalAmount, setTA] = useState(0);
  // const [options, setOptions] = useState([]);

  // useEffect(() => {
  //   setOptions(productList);
  // }, []);

  useEffect(() => {
    let subTotal = calculateTotalAmount(watchProduct);
    setValue("subTotal", subTotal);

    const discount = getValues("discount");
    let newTotalAmount = parseFloat(subTotal - discount, 10).toFixed(2);
    if (subTotal - discount < 0) newTotalAmount = 0;
    setValue("totalAmount", newTotalAmount);
  }, [watchProduct]);

  const calculateTotalAmount = (amountArray) => {
    let totalAmount = 0;
    amountArray.forEach((element) => {
      totalAmount = totalAmount + element * 1;
    });
    const fixedTAmount = parseFloat(totalAmount, 10).toFixed(2);
    return fixedTAmount;
  };

  const [tax, setTax] = useState(0);
  const [ratePerUnit, setRatePerUnit] = useState(0);
  const [amount, setItemAmount] = useState(0);

  const updateProductListInfo = (data) => {
    if (!data) {
      // Empty Product selected
      setRatePerUnit(0);
      setTax(0);
      setItemAmount(0);
      // To trigger Total Amount change with watcher listening.
      setValue(`itemList[${index}].amount`, 0);
    } else {
      if (
        data.hasOwnProperty("name") &&
        data.hasOwnProperty("rate") &&
        data.hasOwnProperty("taxRate")
      ) {
        const productInSelect = getValues(`itemList[${index}].product`);

        // Update RatePerUnit,tax of the selected Item
        const RPU = productInSelect.rate;
        const tax = productInSelect.taxRate;
        setRatePerUnit(RPU);
        setTax(tax);

        // Re-calculate the amount of a particular list item of n units
        updateItemAmount();
      }
    }
  };

  // Update Individual Amount of a List Item.
  const updateItemAmount = () => {
    // If no product is selected
    if (!getValues(`itemList[${index}].product`)) return;
    // console.log("Product: ", getValues(`itemList[${index}].product`));

    // Calculate Amount for a particular item of n units
    const productInSelect = getValues(`itemList[${index}].product`);
    const units = getValues(`itemList[${index}].units`);
    const RPU = productInSelect.rate;
    const tax = productInSelect.taxRate;

    const amount = parseFloat(
      units * RPU + (tax * units * RPU) / 100,
      10
    ).toFixed(2);

    setItemAmount(amount);
    // To trigger Total Amount change with watcher listening.
    setValue(`itemList[${index}].amount`, amount);
  };

  const onUnitsChange = () => {
    if (!getValues(`itemList[${index}].product`)) return;

    const productInSelect = getValues(`itemList[${index}].product`);
    const units = getValues(`itemList[${index}].units`);
    const RPU = getValues(`itemList[${index}].ratePerUnit`);
    const tax = productInSelect.taxRate;

    const amount = parseFloat(
      units * RPU + (tax * units * RPU) / 100,
      10
    ).toFixed(2);

    setItemAmount(amount);

    // To trigger Total Amount change with watcher listening.
    setValue(`itemList[${index}].amount`, amount);
  };

  const onRateChange = () => {
    if (!getValues(`itemList[${index}].product`)) return;

    // Calculate Amount for a particular item of n units
    const productInSelect = getValues(`itemList[${index}].product`);
    const units = getValues(`itemList[${index}].units`);
    const RPU = getValues(`itemList[${index}].ratePerUnit`);
    const tax = productInSelect.taxRate;

    setRatePerUnit(RPU);

    const amount = parseFloat(
      units * RPU + (tax * units * RPU) / 100,
      10
    ).toFixed(2);

    setItemAmount(amount);
    // To trigger Total Amount change with watcher listening.
    setValue(`itemList[${index}].amount`, amount);
  };

  const removeItemLine = () => {
    remove(index);
  };

  return (
    <div
      className="md:flex mt-4 px-3 pb-4 pt-4 md:pt-2 rounded md:rounded-b-none border md:border-0 md:border-b border-gray-400"
      key={item.id}
    >
      {/* productName */}
      <div className="lg:w-1/2 md:w-1/2 w-full pr-6 flex flex-row">
        <div className="flex-grow mr-2">
          <label
            className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor={`itemList[${index}].productName`}
          >
            Item
          </label>

          <MuiItemAutoComplete
            id={`itemList[${index}].product`}
            name={`itemList[${index}].product`}
            autoComplete={true}
            control={control}
            options={productList}
            inputProps={{ placeholder: "Select an item" }}
            customChangeCB={updateProductListInfo}
            setFormValue={setValue}
            onAddNewItem={onAddNewItem}
          />
          {errors.itemList &&
            errors.itemList[index] &&
            errors.itemList[index].product && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.itemList[index].product.message}</span>
              </div>
            )}
        </div>

        <div className="flex-shrink w-1/5">
          <label
            className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor={`itemList[${index}].units`}
          >
            Units
          </label>
          <MuiTextField
            placeholder="Units"
            id={`itemList[${index}].units`}
            name={`itemList[${index}].units`}
            inputProps={{ type: "number", min: 1 }}
            inputRef={register()}
            onChange={onUnitsChange}
            defaultValue={1}
          />
          {errors.itemList &&
            errors.itemList[index] &&
            errors.itemList[index].units && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.itemList[index].units.message}</span>
              </div>
            )}
        </div>
      </div>

      <div className="mt-4 md:mt-0 lg-mt-0 xl:mt-0 flex flex-row lg:w-1/2 md:w-1/2 w-full mb-0">
        {/* Rate Per Unit */}
        <div className="w-2/6 flex-grow mb-1 mr-2">
          <label
            className="block truncate sm:tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor={`itemList[${index}].ratePerUnit`}
          >
            Rate/Unit
          </label>
          <MuiTextField
            placeholder="Rate"
            value={ratePerUnit}
            // inputProps={{ readOnly: true }}
            inputProps={{ type: "number", min: 0 }}
            name={`itemList[${index}].ratePerUnit`}
            inputRef={register()}
            onChange={onRateChange}
          />
        </div>

        {/* Tax */}
        <div className="w-1/6 flex-grow mb-1 mr-2">
          <label
            className="block truncate sm:tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor={`itemList[${index}].tax`}
          >
            Tax ( % )
          </label>
          <MuiTextField
            placeholder="Tax"
            value={tax}
            inputProps={{ readOnly: true }}
            // name={`itemList[${index}].tax`}
            // inputRef={register()}
          />
        </div>

        {/* Amount */}
        <div className="w-2/6 flex-grow mb-1">
          <label
            className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor={`itemList[${index}].amount`}
          >
            Amount
          </label>
          <MuiTextField
            placeholder="Amount"
            id={`itemList[${index}].amount`}
            name={`itemList[${index}].amount`}
            inputRef={register()}
            value={amount}
            inputProps={{ readOnly: true }}
          />
          {errors.amount && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.amount}</span>
            </div>
          )}
        </div>

        {/* Delete Row Button */}
        <div className="w-1/10 ml-2 pt-4 flex items-center justify-center">
          <MdRemoveCircle
            onClick={removeItemLine}
            className="rounded hover:bg-red-200"
            size="1em"
          />
        </div>
      </div>
    </div>
  );
};
